const Background = () => {
  return (
    <div className="bg">
      <img src={process.env.PUBLIC_URL + "images/bg_copy.jpg"} alt="bg" />
    </div>
  );
};

export default Background;
